import { render } from "./SocketExample.vue?vue&type=template&id=399e95e0&ts=true"
import script from "./SocketExample.vue?vue&type=script&lang=ts"
export * from "./SocketExample.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__